import SuccessIcon from 'src/assets/svg/success-icon'
import FailureIcon from 'src/assets/svg/failure-icon'
import SuccessPasswordIcon from 'src/assets/svg/success-password-icon'
import SubsidiarySuccessIcon from 'src/assets/svg/subsidiary-success-icon'
import AddressVerifiedIcon from 'src/assets/svg/address-verified-success-icon'

const popIcons = {
    SUCCESS: <SuccessIcon />,
    FAILURE: <FailureIcon />,
    PASSWORD_SUCCESS: <SuccessPasswordIcon/>,
    SUBSIDIARY: <SubsidiarySuccessIcon />,
    ADDRESS_VERIFICATION: <AddressVerifiedIcon />
}

export default popIcons